/**
 * Centralized API functions for Language functionality
 */
import { postData, getData, putData , deleteData} from '../apiClient';

   // create user ** // Updated Api Error Handle Method
export const createLanguage = async ({ data }) => {
    try {
      const result = await postData(`/language/create`, data);
      
      return {
        data: {
          success: true,
          data: result,
        },
      };
    } catch (error) {
      console.error("Language API error:", error.status === 400 ? error.error : error.message);
      return {
        data: {
          success: false,
          error: error.status === 400 ? error.error : error.message,
          status: error.status,
        },
      };
    }
  };

// get all languages with pagination
export const getLanguagesWithPagination = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
    try {
      const queryParams = new URLSearchParams({
        page: String(page),
        limit: String(limit),
        search: search,
      });
  
      const result = await getData(`/language/get/?${queryParams}`, {}, {}, signal);
      return {
        success: true,
        ...result,
      };
    } catch (error) {
      console.error("Get Languages with pagination API error:", error);
      return {
        success: false,
        ...error,
      };
    }
  };

  // get language phrases for editing
  export const getLanguagePhrases = async ({ page = 1, limit = 10, search = "" }, signal = null,language) => {
    try {
        const queryParams = new URLSearchParams({
            page: String(page),
            limit: String(limit),
            search: search,
          });
      
          const result = await getData(`/language/get/${language}/?${queryParams}`, {}, {}, signal);
      return {
        success: true,
        ...result,
      };
    } catch (error) {
      console.error("Get Languages with pagination API error:", error);
      return {
        success: false,
        ...error,
      };
    }
  };

// get all languages
export const getLanguages = async () => {
    try {
        const result = await getData('/language/get');
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Get languages API error:', error);
        return {
            data: {
                success: false,
                error: error.message,
                data: []
            }
        };
    }
};

// update language
export const updateLanguage = async ({ id, updates }) => {
    try {
        const result = await putData(`/language/update/${id}`, updates);

        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Update language API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};



// delete language
export const deleteLanguage = async ({id}) => {
    try {
        const result = await deleteData(`/language/delete/${id}`);
        return {
            data: {
                message: result.message,
                success: true,
                data: result.data
            }
        };
    } catch (error) {
        console.error('Delete language API error:', error);
        return {
            data: {
                success: false,
                error: error.message
            }
        };
    }
};

